


















































































import { Component, Vue, Watch } from "vue-property-decorator";
import DateRangeSelector from "@/components/inputs/DateRangeSelector.vue";
import MultiDoctorSelector from "@/components/inputs/MultiDoctorSelector.vue";
import MultiPatientSelector from "@/components/inputs/MultiPatientSelector.vue";
import { PatientModel } from "@/models/patient";
import { EventType, EventStatus } from "@/models/event";
import EventDetail from "@/components/EventDetail/index.vue";
import EventsTableCard from "@/components/EventsTableCard.vue";
import { EventTypeIcon, EventTypeSelectionCard } from "@/components/EventType";
import { auth as authStore } from "@/store/modules";
import { inject } from "inversify-props";
import { IDoctorService, IPatientService, EventFilter, IAuthService, EventExportFilter, IApiService, IStatService } from "@/interfaces/Services";
import { DateInput } from '@/components/inputs';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { DoctorModel } from "@/models/doctor";
import LambdaDownloader from "@/utils/lambda_downloader";
import patient from "@/lang/hu/patient";

export enum EventActionable { IsPending = 'IsPending' }

@Component({
  components: {
    MultiDoctorSelector,
    MultiPatientSelector,
    EventDetail,
    EventsTableCard,
    EventTypeIcon,
    EventTypeSelectionCard,
    DateInput,
    DateRangeSelector,
  }
})
export class EventExportDetailed extends Vue {
  @inject(DependencyIdentifiers.AuthService)
  private authService!: IAuthService;
  @inject(DependencyIdentifiers.StatService)
  private statService!: IStatService;

  private componentKey = 0;
  private isLoading = false;
  public filter: EventExportFilter = {
    patientIds: [],
    doctorIds: [],
    eventTypes: [],
    eventStatuses: [EventStatus.Approved, EventStatus.Draft],
    from: '',
    until: '',
    fields: [
      'patientName', 'doctorName', 'centerName', 'age', 'weight', 'walkingAid', 'movementActivity',
      'treatmentMethod', 'factorActivities', 'targetJointTypes', 'hasInhibitor',
      'eventType', 'eventTime', 'eventMeta', 'isOnTime', 'administeredDrugName',
      'administeredTotalAmount', 'administeredTakeUnit', 'administeredCount',
      'administeredDrugType'
    ],
  };
  private format = 'xlsx';
  private availableFormats = ['csv', 'xlsx'];

  private get statusMap() {
    return ["draft", "pending", "approved", "rejected"]
      .map((status) => ({
        value: status,
        text: this.$t(`event.status.${status}`) as string
      }));
  }

  private get fieldMap() {
    return [
      "patientName", "doctorName", "centerName", "age", "socialSecurityNo", "weight", "walkingAid",
      "movementActivity", "treatmentMethod", "factorActivities", "targetJointTypes",
      "hasInhibitor", "eventType", "eventTime", "eventMeta", "isOnTime",
      "administeredDrugName", "administeredTotalAmount", "administeredTakeUnit",
      "administeredCount", "administeredDrugType"
    ]
      .map((field) => ({
        value: field,
        text: this.$t(`stat.event.exportFields.${field}`) as string
      }));
  }

  public async mounted(): Promise<void> {
    // this.loadUrlParameters();
  }

  public get isPatient(): boolean {
    return authStore.isPatient;
  }

  public onFilterPatientChange(patientIds: string[] | null): void {
    this.filter.patientIds = patientIds || [];
  }

  public onFilterDoctorChange(doctorIds: string[] | null): void {
    this.filter.doctorIds = doctorIds || [];
  }

  public onEventTypeSelectionChange(value: EventType[]): void {
    this.filter.eventTypes = value.length === 0 ? null : value;
  }

  public onStatusFilterChange(value: string[]): void {
    this.filter.eventStatuses = value as EventStatus[];
  }

  public onFieldFilterChange(value: string[]): void {
    this.filter.fields = value;
  }

  public onDateRangeChanged(from: string, until: string): void {
    this.filter.from = from;
    this.filter.until = until;
  }

  public async onExport() {
    this.isLoading = true;
    try {
      const data = await this.statService.getExport(-1, -1, this.filter, this.format);
      const blob = await LambdaDownloader.dataURItoBlob(data);
      LambdaDownloader.downloadHack(blob, `hemonaplo-event-export.${this.format}`);
    } catch (e) {
      alert('Error');
    } finally {
      this.isLoading = false;
    }
  }

  public async onReset() {
    this.$router.go(0);
  }

  @Watch("format")
  @Watch("filter", {deep: true})
  public onFilterUpdate(): void {
    // this.saveUrlParameters();
  }

  private loadUrlParameters(): void {
    const query = this.$route.query;

    this.filter.eventTypes = query.types ? (query.types as string).split(",") as EventType[]: [EventType.Injection, EventType.Bleeding];
    this.filter.eventStatuses = query.statuses ? (query.statuses as string).split(",") as EventStatus[] : [EventStatus.Approved];
    this.filter.from = query.from ? query.from.toString() : null;
    this.filter.until = query.until ? query.until.toString() : null;
    this.filter.patientIds = query.patientIds ? (query.patientIds as string).split(',') : [];
    this.filter.doctorIds = query.doctorIds ? (query.doctorIds as string).split(',') : [];
    if (query.fields) this.filter.fields = (query.fields as string).split(',');
    this.format = query.format ? query.format.toString() : 'xlsx';
    this.componentKey++;
  }

  private saveUrlParameters() {
    const query = {
      types: this.filter.eventTypes ? this.filter.eventTypes.join(',') : '',
      statuses: this.filter.eventStatuses ? this.filter.eventStatuses.join(',') : '',
      from: this.filter.from ? this.filter.from.toString() : '',
      until: this.filter.until ? this.filter.until.toString() : '',
      patientIds: this.filter.patientIds ? this.filter.patientIds.join(',') : '',
      doctorIds: this.filter.doctorIds ? this.filter.doctorIds.join(',') : '',
      fields: this.filter.fields ? this.filter.fields.join(',') : '',
      format: this.format,
    };

    const serial = JSON.stringify(query);
    const current = JSON.stringify(this.$router.currentRoute.query);
    if (serial == current) { return; }
    this.$router.push({path: '/dashboard/export/events', query: query as any });
  }
}

export default EventExportDetailed;
